import React from 'react';
import gql from 'graphql-tag';
import { EntityDetailFetcher } from '../components/EntityDetailFetcher';
import typeIntro from '../static/introspection/Company360.json';
import good360TypeIntro from '../static/introspection/Good360.json';
import { ENTITY } from '../utils/entities';
import { t } from '../utils/labels';
import { Company360DetailQuery } from 'graphql/query/Company360DetailQuery';
import { Entity360Actions } from '../components/Entity360Actions';
import { StatusSetter } from '../components/StatusSetter';
import { setCompany360StatusMutation } from '../graphql/mutations/setCompany360StatusMutation';
import { setGood360StatusMutation } from '../graphql/mutations/setGood360StatusMutation';
import Status360Introspection from '../static/introspection/Status360.json';
import { transformerHandler } from '../utils/misc';
import { fastTransformer, refactorInfo } from '../utils/form';
import { relation360AdvsTab } from '../components/relation360AdvsTab';

const statuses = Status360Introspection.enumValues.map((o) => o.name);

export const Company360Detail = ({ id }) => (
	<EntityDetailFetcher
		id={id}
		query={Company360DetailQuery}
		entityName={ENTITY.COMPANY_360}
		typeIntro={typeIntro}
		clonable={false}
		forcedPermissions={{ canEdit: false }}
		customActionComponents={(entity) => [
			<StatusSetter
				key="status"
				statuses={statuses}
				entityName={ENTITY.COMPANY_360}
				entity={entity}
				statusFieldName="status"
				mutation={setCompany360StatusMutation}
				entityIntrospection={typeIntro}
			/>,
			<Entity360Actions
				key="actions"
				entity={entity}
				entityName={ENTITY.COMPANY_360}
			/>,
		]}
		fields={[
			'status',
			'companyLevel',
			'Company',
			'Service',
			'FoodService',
			'Retailer',
			'Brand',
			'Relation360_Advs',
			'Relation360_Good360s',
		]}
		transformer={transformerHandler(
			fastTransformer({
				// ADV collegate (via Relation360): cartella in sola lettura con "Imposta Stato"
				Relation360_Advs: relation360AdvsTab(1),
				// La relazione con i Good360 (via Relation360) diventa una "cartella" (tab)
				// con la lista dei Good360 collegati a questa Company360. Ogni riga espone solo
				// l'azione "Imposta Stato", nessun altro controllo.
				Relation360_Good360s: (f) => {
					if (f.type !== 'EntityList') {
						refactorInfo(f, 'EntityList');
						return f;
					}
					f.tab = 2;
					f.props.headers = ['Good', 'status'];
					f.props.denyAdd = true;
					f.props.hideDetailAction = true;
					f.props.fragment = gql`
						fragment Fragment on Good360 {
							id
							localId
							status
							Good {
								id
								name
							}
						}
					`;
					f.props.customFields = [
						{
							header: 'setStatus',
							field: (good360) => ({
								name: 'setStatus',
								type: 'Custom',
								value: (
									<StatusSetter
										statuses={statuses}
										entityName={ENTITY.GOOD_360}
										entity={good360}
										statusFieldName="status"
										mutation={setGood360StatusMutation}
										entityIntrospection={good360TypeIntro}
									/>
								),
							}),
						},
					];
					return f;
				},
			}),
		)}
		tabs={[
			t('generic data'),
			t(['Company360', 'Advs', 'label'].join('/')),
			t(['Company360', 'relations', 'Good360s'].join('/')),
		]}
		cols={[['col-sm-12'], ['col-sm-12'], ['col-sm-12']]}
	/>
);